import { PlayerPreview } from '@/components/preview/PlayerPreview/PlayerPreview';

export const EventDataLockerPlayerPreview = () => <PlayerPreview />;
